import { render, staticRenderFns } from "./AnonymizeInvolvedParty.vue?vue&type=template&id=7bcefdae&scoped=true"
import script from "./AnonymizeInvolvedParty.vue?vue&type=script&lang=ts"
export * from "./AnonymizeInvolvedParty.vue?vue&type=script&lang=ts"
import style0 from "./AnonymizeInvolvedParty.vue?vue&type=style&index=0&id=7bcefdae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bcefdae",
  null
  
)

export default component.exports